import {useTheme} from "@emotion/react";
import {useEffect, useState} from "react";
import bibModal from "../../assets/images/modal/bibModal.png";
import closeModal from "../../assets/images/modal/closeModal.png";

import SectionWrapper from "../../layouts/SectionWrapper/index.jsx";
import {BibImg, Close, CloseButtonWrapper, ModalWrapper, Overlay} from "./style.js";

import {Form, useLoaderData} from "@remix-run/react";
import {getFromLS} from "../../utils/localStorage.js";
import {ModalForm} from "../forms/modalForm.jsx";

const CustomModal = ({handleClose, isOpen}) => {
  if (!isOpen) return null;

  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;

  return (
    <Overlay>
      <SectionWrapper styles={{width: "100% !important", backgroundColor: "transparent"}}>
        <ModalWrapper>
          <Form method={"post"} navigate={false}>
            <CloseButtonWrapper
              name={"_action"}
              value={"newsLetterInaction"}
              type={"submit"}
            >
              <Close alt={"close-button"} src={closeModal} />
            </CloseButtonWrapper>
          </Form>

          {!isMobile && <BibImg src={bibModal} />}
          <ModalForm handleClose={handleClose} />
        </ModalWrapper>
      </SectionWrapper>
    </Overlay>
  );
};

export const NewsLetterModal = () => {
  const {newsLetterInactionValue} = useLoaderData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClose = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (newsLetterInactionValue) {
      setIsModalOpen(false);
    }
  }, [newsLetterInactionValue]);

  useEffect(() => {
    if (!newsLetterInactionValue) {
      let timeout;

      const resetTimer = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          const formSubmitted = getFromLS("formSubmitted");
          if (!formSubmitted) {
            setIsModalOpen(true);
          }
        }, 2 * 60000);
      };

      const activityEvents = ["mousemove", "keydown", "scroll"];
      activityEvents.forEach((event) => window.addEventListener(event, resetTimer));

      resetTimer();

      return () => {
        activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
        clearTimeout(timeout);
      };
    }
  }, [newsLetterInactionValue]);

  return <CustomModal handleClose={handleClose} isOpen={isModalOpen} />;
};
